import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./customerCreateModalTour.css";

/**
 * Product tour — modal CustomerCreateModal (thêm / cập nhật khách hàng).
 * Các bước gắn qua [data-tour="..."] trong CustomerCreateModal.jsx.
 */
export function startCustomerCreateModalTour({ isEdit = false } = {}) {
  const segments = [
    {
      selector: '[data-tour="customer-create-modal-header"]',
      title: "Tổng quan form",
      description: isEdit
        ? "Cập nhật hồ sơ khách hàng: thông tin nhận diện, CRM, người liên hệ. Các trường có dấu * là bắt buộc theo quy tắc lưu."
        : "Tạo khách hàng mới: điền tên, chi nhánh, loại khách, nguồn khách (khi tạo mới) và cấp học nếu là Trường học.",
      side: "bottom",
    },
    {
      selector: '[data-tour="customer-create-modal-identity"]',
      title: "Thông tin nhận diện",
      description:
        "Tên hiển thị dạng chữ in hoa. Chọn Loại khách hàng; nếu là Trường học thì bắt buộc chọn Cấp học. Điện thoại và địa chỉ là tùy chọn nhưng nên điền đầy đủ.",
      side: "right",
    },
    {
      selector: '[data-tour="customer-create-modal-ops"]',
      title: "Điều phối CRM",
      description:
        "Chi nhánh xác định phạm vi quản lý. Sales phụ trách lọc theo chi nhánh đã chọn — có thể để trống nếu chưa giao.",
      side: "right",
    },
    {
      selector: '[data-tour="customer-create-modal-crm"]',
      title: "Thông tin CRM",
      description: isEdit
        ? "Nguồn khách, trạng thái chăm sóc, tags và ghi chú nội bộ. Tags giúp phân nhóm nhanh trong danh sách và báo cáo."
        : "Nguồn khách là bắt buộc khi tạo mới. Trạng thái mặc định có thể điều chỉnh; dùng Tags và Ghi chú để ghi nhận nhu cầu và lịch sử làm việc.",
      side: "left",
    },
    {
      selector: '[data-tour="customer-create-modal-contacts"]',
      title: "Người liên hệ",
      description:
        "Thêm đầu mối làm việc (tên, SĐT, chức vụ, thông tin ngân hàng trong popup). Có thể sửa hoặc xóa từng người trước khi lưu hồ sơ.",
      side: "left",
    },
    {
      selector: '[data-tour="customer-create-modal-hint"]',
      title: "Lưu ý dữ liệu",
      description:
        "Hồ sơ khách dùng xuyên suốt CRM: chăm sóc, hợp đồng, lịch sử tương tác. Nên khai báo chính xác chi nhánh, nguồn khách và đầu mối liên hệ.",
      side: "top",
    },
    {
      selector: '[data-tour="customer-create-modal-footer"]',
      title: "Lưu hồ sơ",
      description:
        "Hoàn tất & Lưu hồ sơ khi đã đủ thông tin bắt buộc. Nút bị vô hiệu nếu form chưa hợp lệ theo quy tắc phía trên.",
      side: "top",
    },
  ];

  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description: isEdit
          ? "Vài bước giới thiệu các khối thông tin khi cập nhật khách hàng."
          : "Vài bước giới thiệu cách khai báo khách hàng mới đúng luồng CRM.",
        side: "over",
        align: "center",
      },
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Chưa tải đủ vùng giao diện để chạy hướng dẫn. Vui lòng thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "customer-create-modal-tour-popover",
    onPopoverRender: (popover) => {
      popover.wrapper?.setAttribute?.("lang", "vi");
    },
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
